import { AuthoringMock, OperationsMock, TagMapMock } from "../Mocks";

export function HowItWorks() {
  const beats = [
    {
      n: "01",
      t: "Author SQL in the browser.",
      b: "The gateway compiles your script in-browser via WASM. Errors and the output catalog appear inline before you touch any tags.",
      mock: <AuthoringMock compact />,
    },
    {
      n: "02",
      t: "Map inputs to tag patterns.",
      b: "Point each input stream at an Ignition tag pattern. Use path placeholders to key per-identity instances. Smoke-test on a CSV or on live tags first.",
      mock: <TagMapMock />,
    },
    {
      n: "03",
      t: "Deploy as a processor.",
      b: "It runs on the gateway, writes outputs back as tags, and shows up next to everything else in the Operations dashboard.",
      mock: <OperationsMock minimal />,
    },
  ];
  return (
    <section className="section" id="how">
      <div className="section-inner">
        <div className="section-header" style={{ maxWidth: "none" }}>
          <div className="eyebrow">02 · How it works</div>
          <h2>From SQL to a running processor in three steps.</h2>
          <p className="lede">
            Author in the browser, map to tag patterns, then deploy a processor that runs on the
            gateway.
          </p>
        </div>
        <div style={{ display: "grid", gap: 72 }}>
          {beats.map((b, i) => (
            <div
              key={i}
              className="how-step"
              style={{
                display: "grid",
                gridTemplateColumns: "minmax(260px, 360px) 1fr",
                gap: 48,
                alignItems: "start",
              }}
            >
              <div>
                <div style={{ display: "flex", alignItems: "baseline", gap: 14, marginBottom: 14 }}>
                  <div
                    className="mono"
                    style={{
                      fontSize: 48,
                      fontWeight: 300,
                      letterSpacing: "-0.02em",
                      color: "var(--accent-hover)",
                      lineHeight: 1,
                    }}
                  >
                    {b.n}
                  </div>
                  <div
                    className="mono"
                    style={{ fontSize: 10, color: "var(--ink-4)", letterSpacing: "0.1em" }}
                  >
                    STEP {i + 1} OF 3
                  </div>
                </div>
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 500,
                    letterSpacing: "-0.015em",
                    marginBottom: 10,
                    textWrap: "balance",
                  }}
                >
                  {b.t}
                </div>
                <div
                  style={{
                    fontSize: 15,
                    color: "var(--ink-3)",
                    lineHeight: 1.55,
                    maxWidth: 340,
                  }}
                >
                  {b.b}
                </div>
              </div>
              <div style={{ minWidth: 0 }}>{b.mock}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
